import PropTypes from 'prop-types';

function WhySection({ t }) {
    return (
        <section className="why section-panel">
            <div className="content-width why-stage">
                <div className="why-heading">
                    <h2><span>{t('whyTitleA')}</span><span>{t('whyTitleB')}</span></h2>
                    <p>{t('whyIntro')}</p>
                </div>
                <article className="why-card card-left"><p>{t('noAds')}</p></article>
                <div className="why-detail"><p>{t('whyMore')}</p><p>{t('whyLast')}</p></div>
            </div>
        </section>
    );
}

WhySection.propTypes = {
    t: PropTypes.func.isRequired,
};

export default WhySection;
